/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-14T15:25:43.887
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentLeaseContractReceiptAgreement,
	listRentLeaseContractReceiptAgreementInit,
	listRentLeaseContractReceiptAgreementByAuthorizations,
	deleteRentLeaseContractReceiptAgreement
} from '@api/rentmanage/RentLeaseContractReceiptAgreement';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentLeaseContractReceiptAgreement({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractReceiptAgreement(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractReceiptAgreementByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractReceiptAgreementByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractReceiptAgreementInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractReceiptAgreementInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
                        state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLeaseContractReceiptAgreement({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLeaseContractReceiptAgreement({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
